import {mergeInnerProperties} from '../store_utils';
import {
    SET_USER_STATUS,
    SET_PRIME_MEMBER_SELECTED,
    SET_MEMBERSHIP_SUBSCRIPTION_OFFER,
    SET_MEMBERSHIP_DISCOUNT,
    SET_RISKY_CREDIT_CARD,
    SET_EXPIRING_CREDIT_CARD,
    SET_PRICE_SELECTED_RESULTS,
    SET_MEMBERSHIP_CHURN_RISK,
    SET_YEARLY_REJECTED,
} from 'od-modules/secure_store/actions';

export default function prime(state = {}, action) {
    switch (action.type) {
        case SET_USER_STATUS:
            return Object.assign({}, state, {userStatus: action.entry});
        case SET_PRIME_MEMBER_SELECTED:
            if (action.merge) {
                return mergeInnerProperties([], state, {primeMemberSelected: action.entry});
            }
            return Object.assign({}, state, {primeMemberSelected: action.entry});
        case SET_MEMBERSHIP_SUBSCRIPTION_OFFER:
            return mergeInnerProperties([], state, {membershipSubscriptionDetails: action.entry});
        case SET_MEMBERSHIP_DISCOUNT:
            return Object.assign({}, state, {discount: action.entry});
        case SET_RISKY_CREDIT_CARD:
            return Object.assign({}, state, {isRiskyCreditCard: action.entry});
        case SET_EXPIRING_CREDIT_CARD:
            return Object.assign({}, state, {isExpiringCreditCard: action.entry});
        case SET_MEMBERSHIP_CHURN_RISK:
            return mergeInnerProperties([], state, {membershipChurnRisky: action.entry});
        case SET_PRICE_SELECTED_RESULTS:
            return mergeInnerProperties([], state, {membershipSubscriptionDetails: {primePriceSelectedInResults: action.entry}});
        case SET_YEARLY_REJECTED:
            return Object.assign({}, state, {isYearlyRejected: action.entry});
        default:
            return state;
    }
}
